<template>
    <div>
        <template v-if="isLoading">
            <busy-spinner inner-class="p-5"></busy-spinner>
        </template>

        <template v-else>
            <slot />
        </template>
    </div>
</template>

<script>
export default {
    props: ["loading"],
    computed: {
        isLoading() {
            return this.loading;
        },
    },
};
</script>
